import React, { ReactElement } from 'react';
import Modal from '@atlaskit/modal-dialog';
import styled, { createGlobalStyle } from 'styled-components';

import Button from 'kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';

const MODAL_TEST_ID = 'warning-confirmation-modal';

// Atlaskit's modal has barely rounded corners. Mounted only while it's open.
const ModalFrameStyle = createGlobalStyle`
  section[data-testid='${MODAL_TEST_ID}'] {
    border-radius: 12px;
    overflow: hidden;
  }
`;

const MainDiv = styled.div`
  background-color: var(--color-bg-primary);
  padding: 24px;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;
const TextDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const FooterDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const WarningConfirmationModal = ({
  title,
  body,
  isOpen,
  close,
  onConfirmed,
  continueText,
  cancelText,
  isDestructive,
}: {
  title: string;
  body: string | ReactElement;
  isOpen: boolean;
  close: () => void;
  onConfirmed: () => void;
  continueText?: string;
  cancelText?: string;
  // Confirming throws something away (discard, delete...), so it's red
  isDestructive?: boolean;
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      onClose={close}
      shouldScrollInViewport={false}
      autoFocus={false}
      width={448}
      testId={MODAL_TEST_ID}
    >
      <ModalFrameStyle />
      <MainDiv>
        <TextDiv>
          <Typography.Header type="H4">{title}</Typography.Header>
          <Typography.Body type="Body 14" color="var(--color-text-secondary)">
            {body}
          </Typography.Body>
        </TextDiv>
        <FooterDiv>
          <Button
            type="Secondary"
            size="Small"
            onClick={close}
            label={cancelText ?? 'Cancel'}
          />
          <Button
            type={isDestructive ? 'Danger' : 'Primary'}
            size="Small"
            onClick={onConfirmed}
            label={continueText ? continueText : 'Continue'}
            testId="confirm-warning"
          />
        </FooterDiv>
      </MainDiv>
    </Modal>
  );
};

export default WarningConfirmationModal;
